import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface FavoriteFilterProps {
	showFavoritesOnly: boolean;
	setShowFavoritesOnly: (show: boolean) => void;
}

export const FavoriteFilter = ({
	showFavoritesOnly,
	setShowFavoritesOnly
}: FavoriteFilterProps) => {
	const { t } = useTranslation();

	return (
		<Button
			variant={showFavoritesOnly ? "default" : "outline"}
			className="flex items-center gap-2"
			onClick={() => setShowFavoritesOnly(!showFavoritesOnly)}
			title={showFavoritesOnly ? t("filters.showAll", "Show all") : t("filters.showFavoritesOnly", "Show favorites only")}
		>
			<Star className={`h-4 w-4 ${showFavoritesOnly ? 'fill-current' : ''}`} />
			<span className="hidden sm:inline">{t("filters.favorites", "Favorites")}</span>
		</Button>
	);
};
